<template>
  <b-card no-header>
    <div class="d-flex align-items-center mb-3">
      <h5 class="mb-0">Laporan</h5>
      <div class="ml-auto">
        <b-button variant="primary" :disabled="isLoading" @click="loadReports">Tampilkan</b-button>
      </div>
    </div>
    <b-row class="mb-3">
      <b-col cols="12" md="4">
        <label>Periode</label>
        <b-form-select v-model="filters.period" :options="periodOptions" />
      </b-col>
      <b-col cols="12" md="4">
        <label>Tanggal Acuan</label>
        <b-form-input type="date" v-model="filters.date" />
      </b-col>
    </b-row>
    <b-tabs>
      <b-tab title="Penjualan">
        <div class="d-flex mt-3 mb-3">
          <strong>{{ sales.total_transactions || 0 }} transaksi</strong>
          <strong class="ml-auto">Total Rp{{ $formatPrice(sales.total || 0) }}</strong>
        </div>
        <div class="table-responsive">
          <table class="table table-striped">
            <thead><tr><th>No. Invoice</th><th>Tanggal</th><th>Customer</th><th class="text-right">Total</th></tr></thead>
            <tbody>
              <tr v-for="row in sales.data" :key="row.id">
                <td>{{ row.transaction_no }}</td>
                <td>{{ formatDate(row.tanggal_transaksi) }}</td>
                <td>{{ row.costumer ? row.costumer.nama : '-' }}</td>
                <td class="text-right">Rp{{ $formatPrice(row.total) }}</td>
              </tr>
              <tr v-if="!sales.data.length"><td colspan="4" class="text-center">Data tidak ditemukan</td></tr>
            </tbody>
          </table>
        </div>
      </b-tab>
      <b-tab title="Buy Back">
        <div class="d-flex mt-3 mb-3">
          <strong>{{ buyBacks.total_transactions || 0 }} transaksi</strong>
          <strong class="ml-auto">Total Rp{{ $formatPrice(buyBacks.total || 0) }}</strong>
        </div>
        <div class="table-responsive">
          <table class="table table-striped">
            <thead><tr><th>No. Invoice</th><th>Tanggal</th><th>Penjual</th><th class="text-right">Total</th></tr></thead>
            <tbody>
              <tr v-for="row in buyBacks.data" :key="row.id">
                <td>{{ row.transaction_no }}</td>
                <td>{{ formatDate(row.tanggal_transaksi) }}</td>
                <td>{{ row.costumer ? row.costumer.nama : '-' }}</td>
                <td class="text-right">Rp{{ $formatPrice(row.total) }}</td>
              </tr>
              <tr v-if="!buyBacks.data.length"><td colspan="4" class="text-center">Data tidak ditemukan</td></tr>
            </tbody>
          </table>
        </div>
      </b-tab>
      <b-tab title="Perbaikan">
        <div class="d-flex mt-3 mb-3">
          <strong>{{ repairs.total_transactions || 0 }} pencatatan</strong>
          <strong class="ml-auto">Total Rp{{ $formatPrice(repairs.total || 0) }}</strong>
        </div>
        <div class="table-responsive">
          <table class="table table-striped">
            <thead><tr><th>No. Surat</th><th>Tanggal</th><th>Nama Barang</th><th>Kerusakan</th><th class="text-right">Biaya</th></tr></thead>
            <tbody>
              <tr v-for="row in repairs.data" :key="row.id">
                <td>{{ row.transaction_no }}</td>
                <td>{{ formatDate(row.tanggal_perbaikan) }}</td>
                <td>{{ row.nama_barang }}</td>
                <td>{{ row.deskripsi_kerusakan }}</td>
                <td class="text-right">Rp{{ $formatPrice(row.biaya_perbaikan || 0) }}</td>
              </tr>
              <tr v-if="!repairs.data.length"><td colspan="5" class="text-center">Data tidak ditemukan</td></tr>
            </tbody>
          </table>
        </div>
      </b-tab>
      <b-tab title="Ringkasan Stok">
        <div class="table-responsive mt-3">
          <table class="table table-striped">
            <thead><tr><th>Jenis Barang</th><th>Kadar</th><th class="text-right">Total</th><th>Satuan</th><th class="text-right">Jumlah Item</th></tr></thead>
            <tbody>
              <tr v-for="row in stocks" :key="row.jenis_barang + '-' + (row.kadar || 'tanpa-kadar')">
                <td>{{ stockTypeLabel(row.jenis_barang) }}</td>
                <td>{{ row.kadar || 'Tanpa kadar' }}</td>
                <td class="text-right">{{ $formatPrice(row.total) }}</td>
                <td>{{ row.satuan }}</td>
                <td class="text-right">{{ row.jumlah_item }}</td>
              </tr>
              <tr v-if="!stocks.length"><td colspan="5" class="text-center">Data tidak ditemukan</td></tr>
            </tbody>
          </table>
        </div>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import Report from '@/models/Report.js'

const reportModel = new Report()

export default {
  data () {
    return {
      isLoading: false,
      filters: {
        period: 'daily',
        date: this.$moment().format('YYYY-MM-DD')
      },
      periodOptions: [
        { value: 'daily', text: 'Harian' },
        { value: 'weekly', text: 'Mingguan' },
        { value: 'monthly', text: 'Bulanan' },
        { value: 'yearly', text: 'Tahunan' }
      ],
      sales: { data: [], total: 0, total_transactions: 0 },
      buyBacks: { data: [], total: 0, total_transactions: 0 },
      repairs: { data: [], total: 0, total_transactions: 0 },
      stocks: []
    }
  },
  mounted () {
    this.loadReports()
  },
  methods: {
    formatDate (value) {
      return value ? this.$moment(value).format('DD-MM-YYYY') : '-'
    },
    loadReports () {
      this.isLoading = true
      Promise.all([
        reportModel.fetch('sales', this.filters.period, this.filters.date),
        reportModel.fetch('buy-backs', this.filters.period, this.filters.date),
        reportModel.repairs(this.filters.period, this.filters.date),
        reportModel.stocks()
      ]).then(responses => {
        this.sales = responses[0]
        this.buyBacks = responses[1]
        this.repairs = responses[2]
        this.stocks = responses[3]
      }).catch(error => {
        this.$store.dispatch('notification/error', error)
      }).finally(() => {
        this.isLoading = false
      })
    },
    stockTypeLabel (type) {
      return { emas: 'Emas', berlian: 'Berlian', perhiasan: 'Perhiasan' }[type] || type
    }
  }
}
</script>
